import { jsx } from "react/jsx-runtime";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Price from "../Price/Price.js";
import Tooltip from "../Tooltip/Tooltip.js";
import './CarCard.css';/* empty css             */
const CarCardPrice = ({ price, benefits, className }) => {
  const hiddenBenefits = !benefits || benefits.hidden;
  return /* @__PURE__ */ jsx(
    Price,
    {
      title: price.label,
      value: price.currentValue,
      oldValue: price.oldValue,
      oldValuePosition: price.oldValuePosition,
      className: classnames("perxis-auto-car-card-price", className),
      extra: !hiddenBenefits && /* @__PURE__ */ jsx(
        Tooltip,
        {
          showCloseButton: true,
          destroyTooltipOnHide: true,
          trigger: "hover",
          placement: "top",
          title: benefits == null ? void 0 : benefits.tooltipTitle,
          content: benefits == null ? void 0 : benefits.tooltipContent,
          className: classnames("perxis-auto-car-card-price__benefits"),
          children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-car-card-price__benefits-icon"), children: /* @__PURE__ */ jsx(Icon, { name: "question" }) })
        }
      )
    }
  );
};
export {
  CarCardPrice as default
};
//# sourceMappingURL=CarCardPrice.js.map
